import { ObservabilityEngine } from './ObservabilityEngine'
import { NullAdapter } from './adapters/NullAdapter'
import { OpenObserveAdapter } from './adapters/OpenObserveAdapter'

// VITE_OBSERVABILITY_PROVIDER = 'sentry' | 'glitchtip' | 'openobserve' | 'null'
const PROVIDER = import.meta.env.VITE_OBSERVABILITY_PROVIDER ?? 'null'

async function createAdapter() {
  switch (PROVIDER) {
    case 'sentry': {
      const { SentryAdapter } = await import('./adapters/SentryAdapter')
      return new SentryAdapter()
    }
    case 'glitchtip': {
      const { GlitchTipAdapter } = await import('./adapters/GlitchTipAdapter')
      return new GlitchTipAdapter()
    }
    case 'openobserve':
      return new OpenObserveAdapter()
    default:
      return new NullAdapter()
  }
}

export const observability = new ObservabilityEngine(createAdapter)
